import { useEffect, useState } from "react";
import api from "../../services/api";
import { useAppContext } from "../context/AppContext";
import toast from "react-hot-toast";
import "./style.css";

function Assinatura() {

  const { codusuarionuvem } = useAppContext();

  const [planos, setPlanos] = useState([]);
  const [loading, setLoading] = useState(false);

  const [etapa, setEtapa] = useState(1);
  const [planoSelecionado, setPlanoSelecionado] = useState(null);

  const [pix, setPix] = useState(null);

  useEffect(() => {
    carregarPlanos();
  }, []);

  async function carregarPlanos() {
    try {
      const response = await api.get("v1/planos");
      const planosOrdenados = response.data.sort(
        (a, b) => a.periodomeses - b.periodomeses
      );
      setPlanos(planosOrdenados);
    } catch {
      toast.error("Erro ao carregar planos");
    }
  }

  function calcularDesconto(plano, precoMensal) {
    const valorSemDesconto = precoMensal * plano.periodomeses;
    const desconto = ((valorSemDesconto - plano.valor) / valorSemDesconto) * 100;
    return desconto.toFixed(0);
  }

  function escolherPlano(plano) {
    setPlanoSelecionado(plano);
    setEtapa(2);
  }

  async function pagarPix() {
    setLoading(true);
    try {
      const response = await api.post("v1/criarassinatura", {
        codusuario: codusuarionuvem,
        codplano: planoSelecionado.codplano,
        formapagamento: "PIX"
      });
      setPix(response.data);
      setEtapa(3);
      toast.success("PIX gerado!");
    } catch {
      toast.error("Erro ao gerar pagamento");
    }
    setLoading(false);
  }

  async function pagarCartao() {

    toast("Pagamento por cartão será aberto na próxima etapa");

  }

  const precoMensal = planos.length ? planos[0].valor : 10;

  const planoRecomendado =
    planos.length > 0
      ? planos.reduce((prev, atual) =>
        atual.valor / atual.periodomeses <
          prev.valor / prev.periodomeses
          ? atual
          : prev
      )
      : null;

  return (

    <div className="assinatura-container">

      <div className="assinatura-header">

        <h1>Continue organizando sua vida financeira</h1>

        <p> Saber exatamente para onde seu dinheiro está indo é o primeiro passo para ter uma vida financeira saudável. </p>
        <p> Com o <b>iContas</b> você acompanha seus gastos, controla receitas, define metas financeiras e entende melhor seus hábitos de consumo. </p>
        <p> Milhares de pessoas descobrem que estão gastando mais do que imaginavam em pequenas despesas do dia a dia. Quando você visualiza seus números, tomar decisões melhores se torna muito mais fácil. </p>

      </div>

      <div className="beneficios-gerais"> 
        <h2>Com o iContas você pode:</h2> 
        <ul> 
          <li>✔ Controlar todas as suas despesas em um único lugar</li> 
          <li>✔ Visualizar onde está gastando mais</li> 
          <li>✔ Criar metas financeiras e acompanhar progresso</li> 
          <li>✔ Planejar melhor seu futuro financeiro</li> 
          <li>✔ Tomar decisões mais conscientes sobre seu dinheiro</li> 
        </ul> 
      </div>

      {/* ETAPA 1 */}
      {etapa === 1 && (

        <>

          <h2 className="titulo-planos">Escolha seu plano</h2>

          <div className="planos">

            {planos.map((plano) => {

              const desconto = calcularDesconto(plano, precoMensal);

              const recomendado =
                planoRecomendado &&
                plano.codplano === planoRecomendado.codplano;

              return (

                <div
                  key={plano.codplano}
                  className={`plano-card ${recomendado ? "destaque" : ""}`}
                >

                  {recomendado && (
                    <div className="badge">
                      MELHOR CUSTO BENEFÍCIO
                    </div>
                  )}

                  <h3>{plano.nome}</h3>

                  <p className="valor">
                    R$ {plano.valor}
                  </p>

                  <p className="periodo">
                    {plano.periodomeses} meses
                  </p>

                  {plano.periodomeses > 1 && (

                    <p className="desconto">

                      Economize {desconto}% em relação ao mensal

                    </p>

                  )}

                  <button
                    onClick={() => escolherPlano(plano)}
                  >

                    Escolher plano

                  </button>

                </div>

              );

            })}

          </div>

        </>

      )}

      {/* ETAPA 2 */}

      {etapa === 2 && planoSelecionado && (

        <div className="pagamento-box">

          <h2>Escolha a forma de pagamento</h2>

          <p>
            Plano escolhido: <b>{planoSelecionado.nome}</b>
          </p>

          <div className="formas-pagamento">

            <button
              className="btn-pagamento"
              onClick={pagarCartao}
              disabled={loading}
            >

              💳 Pagar com Cartão

            </button>

            <button
              className="btn-pagamento"
              onClick={pagarPix}
              disabled={loading}
            >

              ⚡ Pagar com PIX

            </button>

          </div>

          <button
            className="btn-voltar"
            onClick={() => setEtapa(1)}
          >

            ← Voltar

          </button>

        </div>

      )}

      {/* ETAPA 3 */}

      {etapa === 3 && pix && (

        <div className="pix-box">

          <h2>Pagamento via PIX</h2>

          <p>Escaneie o QR Code abaixo:</p>

          <img src={pix.qrcode} alt="pix" />

          <textarea
            readOnly
            value={pix.payload}
          />

        </div>

      )}

    </div>

  );

}

export default Assinatura;